//Vistas de la aplicación
import componentUsers from 'orden_express/users/UsersMain.jsx';
import componentUsersForm from 'orden_express/users/UsersForm.jsx';
import componentDeliveryPoints from 'orden_express/users/UsersDeliveryPoint.jsx'
import componentProducts from 'orden_express/products/ProductsMain.jsx';
import componentProductsForm from 'orden_express/products/ProductsForm.jsx';
import componentOrderBegining from 'orden_express/orders/OrderBegining.jsx';
import componentOrderRequested from 'orden_express/orders/OrderRequested.jsx';
import componentRoutesForm from 'orden_express/routes/RoutesForm.jsx';
import componentOrderDetail from 'orden_express/orders/OrderDetail.jsx';
import componentReportProducts from 'orden_express/reports/ReportProducts.jsx';
import componentReportHistoryClient from 'orden_express/reports/ReportHistoryClient';
import componentDashboardOrdenExpress from 'orden_express/reports/DashboardOrdenExpress.jsx';
import componentLogin from 'orden_express/login/Login.jsx';
//import componentLogout from 'orden_express/login/Logout.jsx';
//Usadas en las operaciones del lado del servidor
//export const URL_SERVER = 'http://192.168.1.60:8080';
// export const URL_SERVER ='http://34.221.31.145:8080/ordenexpress'
// export const URL_SERVER ='http://ordenexpressdemo.shop:8080' //demo hostinger
export const URL_SERVER ='http://2.24.197.113:8080' //prod hostinger
// export const URL_SERVER ='http://149.100.154.11:9000'

export const routesAuth = [
  {
    path: '/login',
    name: 'Login',
    mini: 'L',
    component: componentLogin,
    layout: '/auth',
    hide: true,
  }
]
export const routesAdmin = [
  {
    path: '/users',
    name: 'Usuarios',
    icon: 'nc-icon nc-single-02',
    component: componentUsers,
    layout: '/admin',
  },
  {
    path: '/usersForm',
    name: 'Usuarios',
    mini: 'UF',
    component: componentUsersForm,
    layout: '/admin',
    hide: true,
  },
  {
    path: '/usersDeliveryPoints',
    name: 'Usuarios',
    mini: 'UP',
    component: componentDeliveryPoints,
    layout: '/admin',
    hide: true,
  },
  {
    path: '/products',
    name: 'Productos',
    icon: 'nc-icon nc-box',
    component: componentProducts,
    layout: '/admin',
  },
  {
    path: '/productsForm',
    name: 'Productos',
    icon: 'nc-icon nc-box',
    component: componentProductsForm,
    layout: '/admin',
    hide: true,
  },
  {
    path: '/makeOrder',
    name: 'Solicitud',
    icon: 'nc-icon nc-cart-simple',
    component: componentOrderBegining,
    layout: '/admin'
  },
  {
    path: '/processOrders',
    name: 'Órdenes',
    icon: 'nc-icon nc-bullet-list-67',
    component: componentOrderRequested,
    layout: '/admin'
  },
  {
    path: '/editOrder',
    name: 'Editar solicitud',
    mini: 'ES',
    component: componentOrderDetail,
    layout: '/admin',
    hide: true,
  },
  {
    path: '/routesForm',
    name: 'Formulario de Rutas',
    mini: 'UF',
    component: componentRoutesForm,
    layout: '/admin',
    hide: true,
  },
  {
    collapse: true,
    name: 'Reportes',
    icon: 'nc-icon nc-chart-bar-32',
    state: 'reportsCollapse',
    views: [
      {
        path: '/consolidated',
        name: 'Consolidado',
        mini: 'CO',
        icon: 'nc-icon nc-paper  ',
        component: componentReportProducts,
        layout: '/admin'
      },
      {
        path: '/dashboard',
        name: 'Tablero',
        mini: 'TA',
        icon: 'nc-icon nc-layout-11',
        component: componentDashboardOrdenExpress,
        layout: '/admin'
      },
      {
        path: '/historialClient',
        name: 'Histórico',
        mini: 'HI',
        icon: 'nc-icon nc-calendar-60',
        component: componentReportHistoryClient,
        layout: '/admin'
      },
    ]
  },
  /*{
    path: '/Logout',
    name: 'Salir',
    icon: 'nc-icon nc-button-power',
    component: componentLogout,
    layout: '/admin',
    usingScript:'javascript:void(0)'
  },*/
]

export const routesClient = [
  
  {
    path: '/usersForm',
    name: 'Mis datos',
    icon: 'nc-icon nc-single-02',
    component: componentUsersForm,
    layout: '/client',
    hide: false,
  },
  
  {
    path: '/products',
    name: 'Productos',
    icon: 'nc-icon nc-box',
    component: componentProducts,
    layout: '/client',
    hide:true
  },
  {
    path: '/makeOrder',
    name: 'Solicitud',
    icon: 'nc-icon nc-cart-simple',
    component: componentOrderBegining,
    layout: '/client'
  },
  {
    path: '/processOrders',
    name: 'Órdenes',
    icon: 'nc-icon nc-bullet-list-67',
    component: componentOrderRequested,
    layout: '/client'
  },
  {
    path: '/historialClient',
    name: 'Histórico',
    icon: 'nc-icon nc-calendar-60',
    component: componentReportHistoryClient,
    layout: '/client'
  },
  {
    path: '/editOrder',
    name: 'Editar solicitud',
    mini: 'ES',
    component: componentOrderDetail,
    layout: '/client',
    hide: true,
  },
  /*{
    path: '/Logout',
    name: 'Salir',
    icon: 'nc-icon nc-button-power',
    component: componentLogout,
    layout: '/client',
  },*/
];